import React from 'react'
import PropTypes from 'prop-types'
import times from 'utils/times'
import { Image } from 'components/qstrap'

const AptitudeQuestionItemRiasec = ({
  number, content, answer, onClickHandler,
}) => (
  <div>
    <div><b>{number}. {content.riasec_question}</b></div>
    <div className="AptitudeQuestionItemRiasec">
      {
        times(5, (i) => {
          const img = ((i + 1) === answer) ? 'color' : 'grey'

          return (
            <Image
              data-answer-id={`${number}-${i + 1}`}
              data-testid={`${number}-${i + 1}`}
              key={`answer-${number}-${i + 1}`}
              src={`/assets/img/riasec_emoji/${i + 1}/${img}.svg`}
              onClick={() => { onClickHandler(i + 1) }}
            />
          )
        })
      }
    </div>
  </div>
)

AptitudeQuestionItemRiasec.propTypes = {
  content: PropTypes.object.isRequired,
  answer: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  onClickHandler: PropTypes.func,
}

AptitudeQuestionItemRiasec.defaultProps = {
  onClickHandler: () => {},
}

export default AptitudeQuestionItemRiasec
